import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { UserService, SearchService } from 'gw-capability-gateway';
import { InlineLoader } from '@jutro/components';
import { MLPortalSettingsService} from 'gw-capability-quoteandbind';
import metadata from './MLGroupFinderDialogModal.metadata.json5';
import styles from './MLGroupFinderDialogModal.module.scss';

function MLGroupFinderDialogModal(props) {
    const {
        updateSelectedGroup, populateAvailableProducerCodes, authHeader, writeFilterData, onSave, onCancel, viewModelService
    } = props;

    const { refreshData } = useDataRefresh();
    const groupRequest = viewModelService.create({}, 'pc', 'edge.capabilities.gateway.search.dto.SearchRequestDTO');
    const [requestVM] = useState(groupRequest);
    const [groupResults, updateGroupResults] = useState([]);
    const [noGroupsResults, updateNoGroupsResults] = useState(false);
    const [chosenGroup, updateChosenGroup] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [chooseGroupLoading, setChooseGroupLoading] = useState(false);
    const [enableChangeGroupBasedOnGroupPublicID, setEnableChangeGroupBasedOnGroupPublicID] = useState(false);

    const populateSearchGroupName = (group) => {
        if (_.isUndefined(group)) {
            return;
        }
        writeFilterData(group.groupName, 'groupName_ML');
        writeFilterData(group.publicID, 'groupPublicID_ML');

    };

    const retrieveAssociatedProducerCodes = async () => {
        const producerCodePromise = UserService.getProducerCodesForGroup(_.get(chosenGroup, 'publicID'), authHeader);
        setChooseGroupLoading(true);
        // ModalService.showProgressDialog('agent.controllers.MLPoliciesReportCtrl.Retrieving Group Details...', producerCodePromise);
        producerCodePromise.then((producerCodes) => {
            if (!_.isUndefined(producerCodes)) {
                updateSelectedGroup({...chosenGroup, producerCodes: producerCodes});
                populateAvailableProducerCodes(producerCodes);
            }
            if (onSave) {
                onSave();
            }
        }).catch(() => {
            updateNoGroupsResults(true);
        }).finally(() => {
            setChooseGroupLoading(false);
        });
    };

    const renderSearchLoader = (isLoading) => {
        return isLoading ? <><span>SEARCH</span><InlineLoader loading={isLoading} className="gw-inline-loader" /></> : null;
    };

    const renderChooseLoader = (isLoading) => {
        return isLoading ? <><span>CHOOSE GROUP</span><InlineLoader loading={isLoading} className="gw-inline-loader" /></> : null;
    };

    const onChooseGroup = () => {
        updateSelectedGroup(chosenGroup);
        populateSearchGroupName(chosenGroup);
        retrieveAssociatedProducerCodes(chosenGroup);
    };

    useEffect(() => {
        MLPortalSettingsService.getSettings(authHeader).then((response)=> {
            if (response) {
                setEnableChangeGroupBasedOnGroupPublicID(response.enableChangeGroupBasedOnGroupPublicID_Ext)
            }
        });
    }, [authHeader]);

    const onSearchGroup = () => {
        setLoading(true);
        const groupPromise = SearchService.searchAvailableGroups(requestVM.value, authHeader);
        // ModalService.showProgressDialog('agent.controllers.MLPoliciesReportCtrl.Searching for groups...', groupPromise);
        groupPromise.then((data) => {           
            if (!_.isUndefined(data)) {
                updateGroupResults(data.availableGroups);
            }
            if (!data || !data.availableGroups || data.availableGroups.length < 1) {
                updateNoGroupsResults(true);
            } else {
                updateNoGroupsResults(false);
            }
        }).catch(() => {
            updateNoGroupsResults(true);
        }).finally(() => {
            setLoading(false);
        });
    };

    const writeValue = (value, path) => {
        _.set(requestVM, path, value);
        refreshData();
    };

    const generateDataForRadioButton = (group) => {
        return {
            name: group.groupName,
            code: enableChangeGroupBasedOnGroupPublicID ? group?.publicID : group?.groupID
        };
    };

    const onChangeGroup = (ID) => {
        const groupSelected = _.find(groupResults, (group) => {
            return enableChangeGroupBasedOnGroupPublicID ? group?.publicID === ID : group?.groupID === ID;
        });
        updateChosenGroup(groupSelected);
    };

    const overrides = {
        permissionGroupError: {
            visible: noGroupsResults
        },
        groupResultsTable: {
            data: groupResults
        },
        searchButton: {
            onClick: onSearchGroup,
            disabled: loading,
            content: renderSearchLoader(loading)
        },
        groupNameColumn: {
            option: generateDataForRadioButton,
            value: enableChangeGroupBasedOnGroupPublicID ? _.get(chosenGroup, 'publicID') : _.get(chosenGroup, 'groupID'),
            onValueChange: onChangeGroup
        },
        nextButton: {
            onClick: onChooseGroup,
            disabled: chooseGroupLoading,
            content: renderChooseLoader(chooseGroupLoading)
        },
        cancelButton: {
            onClick: onCancel
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={requestVM}
            onValueChange={writeValue}
            showErrors
            overrideProps={overrides}
            classNameMap={styles}
        />
    );
}

MLGroupFinderDialogModal.propTypes = {
    updateSelectedGroup: PropTypes.func.isRequired,
    populateAvailableProducerCodes: PropTypes.func.isRequired,
    authHeader: PropTypes.string.isRequired,
    writeFilterData: PropTypes.func.isRequired
};
export default MLGroupFinderDialogModal;
